import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import logo from './logo.svg';
import './App.css';
import Home from './components/screens/Home';
import Referal from './components/screens/Referal';
import Recharge from './components/screens/Recharge';
import Account from './components/screens/Account';
import Login from './components/screens/Login';
import Register from './components/screens/Register';
import ForgotPassword from './components/screens/ForgotPassword';
import ChangePassword from './components/screens/ChangePassword';
import Transactions from './components/screens/Transactions';
import AllBankCards from './components/screens/AllBankCards';
import AddBankCard from './components/screens/AddBankCard';
import TradeRecords from './components/screens/TradeRecords';
import Withdraw from './components/screens/Withdraw';
import WithdrawRecords from './components/screens/WithdrawRecords';
import RechargeRecords from './components/screens/RechargeRecords';

import UpdateAccount from './components/screens/UpdateAccount';
import ChangeAvatar from './components/screens/ChangeAvatar';
import ChangeName from './components/screens/ChangeName';
import AllMembers from './components/screens/AllMembers';
import SplashScreen from './components/screens/SplashScreen';
import Dashboard from './components/screens/Dashboard';
import Trade from './components/screens/Trade';
import Trading from './components/screens/Trading';
import HelpSupport from './components/screens/HelpSupport';

function App() {

  return <>
    <Router>

      <Routes>
        <Route path='/home' element={<Home />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/trading' element={<Trading />} />
        <Route path='/trade' element={<Trade />} />
        <Route path='/referal' element={<Referal />} />
        <Route path='/recharge' element={<Recharge />} />
        <Route path='/account' element={<Account />} />
        <Route path='/traderecords' element={<TradeRecords />} />
        <Route path='/transactions' element={<Transactions />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/changepassword' element={<ChangePassword />} />
        <Route path='/forgotpassword' element={<ForgotPassword />} />
        <Route path='/withdraw' element={<Withdraw />} />
        <Route path='/bankcards' element={<AllBankCards />} />
        <Route path='/addbankcard' element={<AddBankCard />} />
        <Route path='/withdrawrecords' element={<WithdrawRecords />} />
        <Route path='/rechargerecords' element={<RechargeRecords />} />
        <Route path='/updateaccount' element={<UpdateAccount />} />
        <Route path='/changeavatar' element={<ChangeAvatar />} />
        <Route path='/changename' element={<ChangeName />} />
        <Route path='/allmembers' element={<AllMembers />} />
        <Route path='/helpsupport' element={<HelpSupport />} />

        {/* default page */}
        <Route path='/' element={<SplashScreen />} />
      </Routes>

    </Router>
  </>;
}

export default App;
